import first from 'lodash/first';

import getLayerIdsFromTiers from './getLayerIdsFromTiers';

export default function getFirstLayerIdsFromTiers(tiers) {
    return getLayerIdsFromTiers(tiers, first);
}



// WEBPACK FOOTER //
// ./map/tier/styleUpdate/getFirstLayerIdsFromTiers.js